define('plugin/client-field/collection/ClientFieldsCollection',['require','plugin/additional-fields/collection/AdditionalFieldsCollection','plugin/client-field/model/ClientFieldModel'],function (require) {

    var Parent = require('plugin/additional-fields/collection/AdditionalFieldsCollection')
    var ClientFieldModel = require('plugin/client-field/model/ClientFieldModel');

    /**
     * Client fields collection
     *
     * @class ClientFieldsCollection
     */
    return Parent.extend({

        url: '/ext/client-fields/',
        model: ClientFieldModel,
        
        comparator: function (model) {
            return parseInt( model.get('position') );
        },
        
        initDefaultValues: function () {
            this.each(function (model) {
                if (!model.get('value') && model.get('default')) {
                    model.set('value', model.get('default'));
                }
                if (!model.get('value')) {
                    switch (model.get('type')) {
                        case 'checkbox':
                            model.set('value', 0);
                            break;
                    }
                }
            });
        },

    });

});
